module.exports = __webpack_public_path__ + "static/img/Frame 1948.527bff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/mobile/Frame 1948.png
// module id = Xpix
// module chunks = 12